<template>
  <div>
    <div class="fanye">
        <div @click="upclick"> &lt;</div>
        <div :class="item==index?'active':''" v-for="item in count" :key="item" @click="selecClick(item)">{{item}}</div>
        <div @click="nuxtclick">&gt;</div>
    </div>
  </div>
</template>

<script>
export default {
  data () {
    return {
      index: 1
    }
  },
  props: {
    count: {
      default: 1
    }
  },
  methods: {

    upclick () {
      if (this.index > 1) {
        this.index--
        this.changePage(this.index)
      }
    },
    nuxtclick () {
      if (this.index < this.count) {
        this.index++
        this.changePage(this.index)
      }
    },
    selecClick (index) {
      this.index = index
      this.changePage(this.index)
    },
    changePage (index) {
      this.$emit('changPage', index)
    }
  }
}
</script>

<style scoped>
.fanye {
  font-size: 0px;
  text-align: center;
  margin-top: 40px;
}
.fanye div {
  display: inline-block;
  font-size: 16px;
  color: #111111;
  width: 40px;
  height: 40px;
  line-height: 40px;
  text-align: center;
  background: #eeeeee;
  margin: 0px 10px;
  -webkit-transition: all 0.2s ease-out;
  -khtml-transition: all 0.2s ease-out;
  -moz-transition: all 0.2s ease-out;
  -o-transition: all 0.2s ease-out;
  transition: all 0.2s ease-out;
}
.fanye div.active {
  background: #cc0001;
  color: #fff;
}
.fanye div.active:hover {
  color: #fff;
}
.fanye div:hover {
  color: #cc0001;
  cursor: pointer;
}
</style>



// WEBPACK FOOTER //
// src/components/pages.vue